import bigCommerceApi from 'bigCommerce/gateways/bigCommerce-api';
import { STRINGS } from 'bigCommerce/strings';

async function triggerInitialSync({ business, pluginId, errorToast }) {
  try {
    const payload = {
      type: 'product',
      plugin_Ref_id: 'EcommBigcommerce',
      ref_id: business,
      plugin_id: pluginId,
    };
    await bigCommerceApi.initialSync(payload);
  } catch (error) {
    if (errorToast) {
      errorToast(STRINGS.INITIAL_SYNC_FAILED);
    }
  }
}

export { triggerInitialSync };
